import { useReducer } from "react";
import api from "../api/organizations";

const intialState = {
    regions: [],
    municipals: []
};

function reducer(state, action) {
    switch (action.type) {
        case "ORG_FORM":
            return {
                ...state,
                regions: action.regions,
                municipals: action.municipals
            };
        default:
            return {
                ...state
            };
    }
}

export default function useOrganizationForm() {
    const [dataSources, dispatch] = useReducer(reducer, intialState);

    function getOrganizationForm() {
        Promise.all([
            api.getRegions(),
            api.getMunicipals()
        ]).then(([regions, municipals]) => {
            dispatch({
                type: "ORG_FORM",
                regions: regions.data,
                municipals: municipals.data
            });
        });
    }

    return {
        dataSources,
        getOrganizationForm
    };
}
